import { Controller } from "stimulus"

export default class InputmaskController extends Controller {
  static targets = [ "input" ]
  initialize() {
    const target = this.inputTarget;
    if (target) { Inputmask("RI[A|9]{7}").mask(target); }
  }
}
